import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@nextui-org/react';
import { debounce } from 'lodash';
import React, { useState } from 'react';

import { HeaderSearchIcon, IconArrowDown, IconFilter, SortMobileIcon } from '@/assets';
import LayoutList from '@/components/list-layout';
import useGetWidth from '@/hooks/useGetWidth';

// import { STATUS_PROCESSING } from '@/types/asset';
import type { TypeLayout } from '../list-layout/useListLayout';

export enum SORT {
  desc = 'DESC',
  asc = 'ASC',
}

const LIST_SORT = [
  {
    key: SORT.desc,
    title: 'Date created (newest)',
  },
  {
    key: SORT.asc,
    title: 'Date created (oldest)',
  },
];

export enum CATEGORY {
  artwork = 'artwork',
  collection = 'collection',
  prompt = 'prompt',
  processing = 'processing',
}

const ListBarProfile: React.FC<{
  type?: TypeLayout;
  changeTypeLayout?: (type: TypeLayout) => void;
  title?: string;
  placeholderSearch?: string;
  isNewOld?: boolean;
  isSearch?: boolean;
  filterContent?: React.ReactNode | React.ReactNode[] | React.ReactElement | React.ReactElement[];
  onChangeSearch?: (value: string) => void;
  onChangeSort?: (value: SORT) => void;
  isFilter?: boolean;
  setSelectedHide?: (value: string) => void;
  // setSelectedMinted?: (value: number[]) => void;
  category?: CATEGORY;
}> = ({
  type,
  changeTypeLayout,
  title,
  placeholderSearch,
  isNewOld = true,
  isSearch = true,
  filterContent,
  onChangeSearch,
  onChangeSort,
  isFilter,
  setSelectedHide,
  category,
}) => {
  const [sort, setSort] = useState<SORT>(SORT.desc);
  const [isHidden, setIsHidden] = useState('unhide');
  // const [isMinted, setIsMinted] = useState([
  //   STATUS_PROCESSING.New,
  //   STATUS_PROCESSING.Retry,
  //   STATUS_PROCESSING.SimilarityChecking,
  //   STATUS_PROCESSING.ViewSimilarity,
  //   STATUS_PROCESSING.Minting,
  //   STATUS_PROCESSING.MintFailed,
  //   STATUS_PROCESSING.Transfering,
  // ]);
  const screenWidth = useGetWidth();
  const handleSort = (sortType: any) => {
    setSort(sortType);
    onChangeSort && onChangeSort(sortType);
  };
  const handleHide = (selectedValue: any) => {
    setIsHidden(selectedValue);
    setSelectedHide && setSelectedHide(selectedValue);
  };
  // const handleIsMinted = (selectedValue: any) => {
  //   setIsMinted(selectedValue);
  //   setSelectedMinted && setSelectedMinted(selectedValue);
  // };

  return (
    <div className="flex flex-wrap items-center justify-between">
      <p className="m-0 text-[18px] font-[600]">{title}</p>
      <div className="flex flex-wrap items-center sm:w-full">
        {isFilter && (
          <Popover
            showArrow
            offset={10}
            placement="bottom"
            motionProps={{
              variants: {
                enter: {
                  y: 0,
                  opacity: 1,
                  transition: {
                    opacity: {
                      duration: 0.15,
                    },
                  },
                },
                exit: {
                  y: '10%',
                  opacity: 0,
                  transition: {
                    opacity: {
                      duration: 0.1,
                    },
                  },
                },
              },
            }}
          >
            <PopoverTrigger>
              <div className="cursor-pointer rounded-full bg-gray-50 p-3 sm:flex sm:h-[40px] sm:w-[40px] sm:items-center sm:justify-center sm:p-0">
                <IconFilter />
              </div>
            </PopoverTrigger>
            <PopoverContent>
              <div className="min-w-[250px] px-2 py-5">
                <div className="">
                  <div className="pb-2 text-14 font-semibold leading-6">Date created</div>
                  <div className="flex gap-2">
                    <div
                      className={`w-fit cursor-pointer rounded-[50px] border-1 border-gray-100  px-[12px] py-[6px] text-13 text-black ${
                        sort === SORT.desc && '!border-black'
                      }`}
                      onClick={() => handleSort(SORT.desc)}
                    >
                      <span className="">Newest</span>
                    </div>
                    <div
                      className={`w-fit cursor-pointer rounded-[50px] border-1 border-gray-100  px-[12px] py-[6px] text-13 text-black ${
                        sort === SORT.asc && '!border-black'
                      }`}
                      onClick={() => handleSort(SORT.asc)}
                    >
                      <span className="">Oldest</span>
                    </div>
                  </div>
                </div>
                <div className="pt-5">
                  <div className="pb-2 text-14 font-semibold leading-6">Hidden</div>
                  <div className="flex gap-2">
                    <div
                      className={`w-fit cursor-pointer rounded-[50px] border-1 border-gray-100 px-[12px] py-[6px] text-13 text-black ${
                        isHidden === 'unhide' && '!border-black'
                      }`}
                      onClick={() => handleHide('unhide')}
                    >
                      <span className="">Unhide</span>
                    </div>
                    <div
                      className={`w-fit cursor-pointer rounded-[50px] border-1 border-gray-100 px-[12px] py-[6px] text-13 text-black ${
                        isHidden === 'hide' && '!border-black'
                      }`}
                      onClick={() => handleHide('hide')}
                    >
                      <span className="">Hide</span>
                    </div>
                  </div>
                </div>
                {/* <div className="pt-5">
                  <div className="pb-2 text-14 font-semibold leading-6">Minted</div>
                  <div className="flex gap-2">
                    <div
                      className={`w-fit cursor-pointer rounded-[50px] border-1 border-gray-100 px-[12px] py-[6px] text-13 text-black ${
                        isMinted.length >= 2 && '!border-black'
                      }`}
                      onClick={() =>
                        handleIsMinted([
                          STATUS_PROCESSING.New,
                          STATUS_PROCESSING.Retry,
                          STATUS_PROCESSING.SimilarityChecking,
                          STATUS_PROCESSING.ViewSimilarity,
                          STATUS_PROCESSING.Minting,
                          STATUS_PROCESSING.MintFailed,
                          STATUS_PROCESSING.Transfering,
                        ])
                      }
                    >
                      <span className="">Unminted</span>
                    </div>
                    <div
                      className={`w-fit cursor-pointer rounded-[50px] border-1 border-gray-100 px-[12px] py-[6px] text-13 text-black ${
                        isMinted.length < 2 && '!border-black'
                      }`}
                      onClick={() => handleIsMinted([STATUS_PROCESSING.Minted])}
                    >
                      <span className="">Minted</span>
                    </div>
                  </div>
                </div> */}
              </div>
            </PopoverContent>
          </Popover>
        )}
        {filterContent && (
          <div className="ml-2">
            <Popover placement="bottom" radius="sm" offset={15}>
              <PopoverTrigger>
                <div className="flex h-[45px] w-[45px] cursor-pointer items-center justify-center rounded-[50%] bg-gray-50">
                  <IconFilter />
                </div>
              </PopoverTrigger>
              <PopoverContent>{filterContent}</PopoverContent>
            </Popover>
          </div>
        )}
        {isSearch && (
          <div
            aria-pressed={category === CATEGORY.prompt}
            aria-checked={category === CATEGORY.processing}
            aria-expanded={category === CATEGORY.artwork || category === CATEGORY.collection}
            className="ml-2 rounded-[100px] bg-gray-50 sm:aria-checked:w-[calc(100%-48px)] sm:aria-expanded:ml-0 sm:aria-expanded:w-[calc(100%-142px)] sm:aria-pressed:ml-0 sm:aria-pressed:w-[calc(100%-48px)]"
          >
            <Input
              classNames={{
                input: ['dark:placeholder:text-white font-normal text-14 pl-1', 'rounded-[100px]'],
                innerWrapper: 'bg-transparent rounded-[100px]',
                inputWrapper:
                  'bg-transparent rounded-[100px] shadow-none h-[45px] sm:h-[40px] min-w-[450px] lg:min-w-[260px] sm:w-[100%] sm:min-w-0',
              }}
              onChange={debounce((e) => onChangeSearch && onChangeSearch(e.target.value), 500)}
              startContent={<HeaderSearchIcon />}
              placeholder={placeholderSearch || 'Search in Artworks'}
            />
          </div>
        )}
        {isNewOld && !isFilter && (
          <div className={`sm:w-[40px]'} ml-2`}>
            <Dropdown>
              <DropdownTrigger>
                {screenWidth > 575 ? (
                  <div className="flex w-[210px] cursor-pointer items-center justify-between rounded-[100px] bg-[#f8f9fd] px-[16px] py-[12px] text-[14px] text-black sm:w-full">
                    {LIST_SORT.find((item) => item.key === sort)?.title}{' '}
                    <IconArrowDown className="-mt-1 ml-1" />
                  </div>
                ) : (
                  <Button className="m-0 hidden h-fit min-w-0 rounded-full bg-gray-50 p-2 md:block">
                    <SortMobileIcon />
                  </Button>
                )}
              </DropdownTrigger>
              <DropdownMenu
                aria-label="Static Actions"
                onAction={(e: any) => {
                  setSort(e);
                  onChangeSort && onChangeSort(e);
                }}
              >
                {LIST_SORT.map((item) => (
                  <DropdownItem key={item.key}>{item.title}</DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        )}
        {type && changeTypeLayout && (
          <div className="ml-2 sm:w-[86px]">
            <LayoutList type={type} changeTypeLayout={changeTypeLayout} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ListBarProfile;
